import { URL_CONSTANTS } from "../_constants";
import { ServiceHelper } from "./ServiceHelper";

export const HostifyService = {
    listListings,
    listListingsByApikey,
}

function listListings(integrationUID: string) {
    return ServiceHelper.getRequest(
        URL_CONSTANTS.INTEGRATION_HOSTIFY_LIST_LISTINGS,
        {
            uid: integrationUID
        }
    );
}

// Listing straight from the apikey is what lets the property picker run BEFORE the
// integration exists. Listing by uid forced the alta to create the row just to be
// able to show the properties, and an alta abandoned at that point left an
// integration with no listing, which syncs the whole Hostify account (BAC-314).
// Kept as its own function instead of an optional argument: the backend takes
// exactly one of the two and rejects both together.
function listListingsByApikey(apikey: string) {
    return ServiceHelper.getRequest(
        URL_CONSTANTS.INTEGRATION_HOSTIFY_LIST_LISTINGS,
        {
            apikey: apikey
        }
    );
}
